/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AnyCnameRecord } from 'dns';

import { getFan,getAllFans, searchFan,getFanByFk, reparent, getAllArchievedFans, restorefan } from '../api/fan';
import { getOctaveBand } from '../api/util';
import { RootState, AppThunk } from '../store';
import { FanDetailsFormInput } from '../utils/formData';

export interface FanState {
  fetching: boolean,
  fanData: any,
  octaveBand: any,
  fansList?: any[]
}

const initialState: FanState = {
  fetching: false,
  fansList: undefined,
  octaveBand: undefined,
  fanData: undefined
}

export const searchFanAsync = createAsyncThunk(
  'fan/search',
  async (fanDetails:FanDetailsFormInput) => {
    const response = await searchFan({fanDetails});

        return response.response;
  }
);

export const getOctaveBandAsync = createAsyncThunk(
  'fan/getOctaveBand',
  async (octaveBandID:string) => {
    const response = await getOctaveBand(octaveBandID);
        return response.response;
  }
);

export const getAllFansData = createAsyncThunk(
  'fan/getAll',
  async () => {
    const response = await getAllFans();
    return response.response;
  }
);
export const getAllArchievedFansData = createAsyncThunk(
  'fan/getAllArchieved',
  async () => {
    const response = await getAllArchievedFans();
    console.log(response)
    return response.response;
  }
);
export const restoreFan = createAsyncThunk(
  'fan/restoreFan',
  async (data:any) => {
    const response = await restorefan(data);
    console.log(response)
    return response.response;
  }
);

export const getFanDataByForeignKey = createAsyncThunk(
  'fan/getFanDataByFk',
  async (data:any) => {
    const response = await getFanByFk(data.path,data.idType,data.id);
    return response.response;
  }
);

export const reparentFan = createAsyncThunk(
  'fan/reparent',
  async (data:any) => {
    const response = await reparent(data);
    return response.response;
  }
);

// export const getAllFans = createAsyncThunk(
//     'fan/getAll',
//     async () => {
//       const response = await getFan();
//       return response.response;
//     }
// );

// export const getFanWithModel = createAsyncThunk(
//     'fan/getAll',
//     async (modelNo:string) => {
//       const response = await getFan(modelNo);
//       return response.response;
//     }
// );

export const fanSlice = createSlice({
    name: 'fan',
    initialState,
    reducers: {
      resetFanStore: (state) => {
        state = initialState;
      }
    },
    extraReducers: (builder) => {
        builder
            .addCase(searchFanAsync.pending, (state) => {
                state.fetching = true;
                state.fansList = undefined
            })
            .addCase(searchFanAsync.fulfilled, (state, action) => {
                state.fetching = false;
                state.fansList = action.payload.data;
                // state.fan = action.payload.data;
            })
            .addCase(searchFanAsync.rejected, (state) => {
                state.fetching = false;
            })

            .addCase(getOctaveBandAsync.pending, (state) => {
              state.fetching = true;
              state.octaveBand = undefined
            })
            .addCase(getOctaveBandAsync.fulfilled, (state, action) => {
                state.fetching = false;
                state.octaveBand = action.payload.data;
                // state.fan = action.payload.data;
            })
            .addCase(getOctaveBandAsync.rejected, (state) => {
                state.fetching = false;
            });
    }
})


export const { resetFanStore } = fanSlice.actions;

export const getPerformanceCurve = (state: RootState) => state.fan.fanData.performance_curves;
export const getFanList = (state: RootState) => state.fan.fansList;
export const getFanData = (state: RootState) => state.fan.fanData;
export const getFanBusy = (state: RootState) => state.fan.fetching;

export default fanSlice.reducer;